export default __webpack_public_path__ + "static/media/leftArrowGrey.067f9139.svg";